import { render } from "./AllBookings.vue?vue&type=template&id=568a9076&scoped=true"
import script from "./AllBookings.vue?vue&type=script&lang=js"
export * from "./AllBookings.vue?vue&type=script&lang=js"

import "./AllBookings.vue?vue&type=style&index=0&id=568a9076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568a9076"]])

export default __exports__